// src/components/ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { canAccessPage } from '../utils/permissions';
import { XCircle, ArrowLeft } from 'lucide-react';

const ProtectedRoute = ({ children, requiredPermissions = [] }) => {
  const { user, loading } = useAuth();

  // Afficher un loader pendant la vérification
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Vérification des permissions...</p>
        </div>
      </div>
    );
  }

  // Rediriger vers login si non connecté
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Vérifier les permissions si nécessaires
  if (requiredPermissions.length > 0 && !canAccessPage(user, requiredPermissions)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
        <div className="max-w-md w-full bg-white rounded-lg shadow-xl p-8 text-center">
          {/* Icône d'erreur */}
          <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-12 h-12 text-red-600" />
          </div>
          
          {/* Titre */}
          <h2 className="text-2xl font-bold text-gray-900 mb-3">
            Accès Refusé
          </h2>
          
          {/* Message */}
          <p className="text-gray-600 mb-2">
            Vous n'avez pas les permissions nécessaires pour accéder à cette page.
          </p>
          
          {/* Info rôle */}
          <div className="bg-gray-50 rounded-lg p-4 mb-6">
            <p className="text-sm text-gray-700">
              <span className="font-semibold">Votre rôle :</span>{' '}
              <span className="text-blue-600 capitalize">{user.role}</span>
            </p>
            <p className="text-xs text-gray-500 mt-2">
              Contactez votre administrateur pour obtenir les accès nécessaires.
            </p>
          </div>
          
          {/* Boutons d'action */}
          <div className="flex gap-3">
            <button
              onClick={() => window.history.back()}
              className="flex-1 flex items-center justify-center gap-2 bg-gray-100 text-gray-700 px-6 py-3 rounded-lg hover:bg-gray-200 transition-colors font-medium"
            >
              <ArrowLeft className="w-4 h-4" />
              Retour
            </button>
            
            <button
              onClick={() => window.location.href = '/'}
              className="flex-1 bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors font-medium"
            >
              Accueil
            </button>
          </div>
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;